"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaginationParam = exports.DEFAULT_PAGE_SIZE = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
exports.DEFAULT_PAGE_SIZE = 10;
function getPaginationParam(pagination, mergedPagination) {
    var param = {
        current: mergedPagination.current,
        pageSize: mergedPagination.pageSize,
    };
    var paginationObj = pagination && typeof pagination === 'object' ? pagination : {};
    Object.keys(paginationObj).forEach(function (pageProp) {
        var value = mergedPagination[pageProp];
        if (typeof value !== 'function') {
            param[pageProp] = value;
        }
    });
    return param;
}
exports.getPaginationParam = getPaginationParam;
function extendsObject() {
    var list = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        list[_i] = arguments[_i];
    }
    var result = {};
    list.forEach(function (obj) {
        if (obj) {
            Object.keys(obj).forEach(function (key) {
                var val = obj[key];
                if (val !== undefined) {
                    result[key] = val;
                }
            });
        }
    });
    return result;
}
function usePagination(total, pagination, onChange) {
    var _a = pagination && typeof pagination === 'object' ? pagination : {}, _b = _a.total, paginationTotal = _b === void 0 ? 0 : _b, paginationObj = tslib_1.__rest(_a, ["total"]);
    var _c = tslib_1.__read((0, react_1.useState)(function () { return ({
        current: 'defaultCurrent' in paginationObj ? paginationObj.defaultCurrent : 1,
        pageSize: 'defaultPageSize' in paginationObj ? paginationObj.defaultPageSize : exports.DEFAULT_PAGE_SIZE,
    }); }), 2), innerPagination = _c[0], setInnerPagination = _c[1];
    // ============ Basic Pagination Config ============
    var mergedPagination = extendsObject(innerPagination, paginationObj, {
        total: paginationTotal > 0 ? paginationTotal : total,
    });
    if (!paginationTotal) {
        // Reset `current` if data length changed. Only reset when paginationObj do not have total
        var maxPage = Math.ceil(total / mergedPagination.pageSize);
        if (maxPage < mergedPagination.current) {
            mergedPagination.current = 1;
        }
    }
    var refreshPagination = function (current, pageSize) {
        if (current === void 0) { current = 1; }
        setInnerPagination({
            current: current,
            pageSize: pageSize || mergedPagination.pageSize,
        });
    };
    var onInternalChange = function (current, pageSize) {
        var paginationPageSize = mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize;
        if (pageSize && pageSize !== paginationPageSize) {
            current = 1;
        }
        if (pagination && pagination.onChange) {
            pagination.onChange(current, pageSize);
        }
        refreshPagination(current, pageSize);
        onChange(current, pageSize || paginationPageSize);
    };
    if (pagination === false) {
        return [{}, function () { }];
    }
    return [
        tslib_1.__assign(tslib_1.__assign({}, mergedPagination), { onChange: onInternalChange }),
        refreshPagination,
    ];
}
exports.default = usePagination;
//# sourceMappingURL=usePagination.js.map